/**************************************************
 * Nombre:       Casilla_Avatar_Titulo_Dato
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {TableCell} from "@mui/material";

const Casilla_Img = ({dato, dir, lineas = 1}) => {


    return (
        <TableCell key={dato} variant={'body'} align={dir}>
            <img src={dato} width={'100%'} height={'auto'} style={{borderRadius: 4, width: 100}}/>
        </TableCell>
    )

}
export default Casilla_Img